import React from 'react';

class SMA8Beacon extends React.Component {

  didLoadImage(e) {
    if (this.props.delegate && typeof this.props.delegate.didLoadImage === 'function') {
      this.props.delegate.didLoadImage(e);
    }
  }

  render() {
    const params = this.props.params;
    const src = `https://px.a8.net/cgi-bin/a8fly/sales?pid=s00000017497001&so=${params.order_id}&si=${params.unit_amount}.${params.number}.${params.total_amount}.${params.item_code}`;
    return(
      <img 
        src={src}
        width="1"
        height="1"
        alt=""
        style={{display: 'none'}}
        onLoad={this.didLoadImage.bind(this)}
      />
    );
  }
}
export default SMA8Beacon;



// WEBPACK FOOTER //
// ./app/javascript/components/others/SMA8Beacon.jsx